import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PageMetaModule, I18nModule } from '@spartacus/core';
import { GenBreadcrumbComponent } from './breadcrumb.component';
import { GenOfflineBadgeComponent } from '../../shared/components/offline-badge/offline-badge.component';

@NgModule({
  imports: [CommonModule, RouterModule, PageMetaModule, I18nModule, GenOfflineBadgeComponent],
  declarations: [GenBreadcrumbComponent],
  exports: [GenBreadcrumbComponent],
})
export class GenBreadcrumbModule {}
